import { IconChevronDown, IconChevronUp, IconSelector } from '@tabler/icons-react';
import type { Column } from '@tanstack/react-table';
import type { ReactNode } from 'react';
import { cn } from '~/common/string/classname';

const ICON_SIZE = 14;

type DataTableColumnHeaderProps<TData, TValue> = {
  column: Column<TData, TValue>;
  children: ReactNode;
  className?: string;
};

export function DataTableColumnHeader<TData, TValue>({
  column,
  children,
  className,
}: DataTableColumnHeaderProps<TData, TValue>) {
  if (!column.getCanSort()) {
    return <div className={cn(className, 'font-semibold')}>{children}</div>;
  }

  const sorted = column.getIsSorted();
  return (
    <div
      className={cn('flex w-full items-center justify-between', className)}
      onClick={() => column.toggleSorting(sorted === 'asc')}
    >
      <div className="flex items-center gap-2">
        <div className="whitespace-nowrap">{children}</div>
        <div>
          {sorted === 'asc' ?
            <IconChevronUp size={ICON_SIZE} />
          : sorted === 'desc' ?
            <IconChevronDown size={ICON_SIZE} />
          : <IconSelector size={ICON_SIZE} />}
        </div>
      </div>
    </div>
  );
}
